export const gifs = {
  // ─── WARMUP ───────────────────────────────────────────
  "Marching in Place": "/gifs/marching.webp",
  "Hip Circle": "/gifs/hip-circle.webp",
  "Leg Swing (forward/back)": "/gifs/leg-swing-forward.webp",
  "Leg Swing (side to side)": "/gifs/leg-swing-lateral.webp",
  "Shoulder Roll": "/gifs/shoulder-roll.webp",
  "Arm Circle": "/gifs/arm-circle.webp",
  "Bodyweight Glute Bridge": "/gifs/glute-bridge.webp",
  "Cat-Cow": "/gifs/cat-cow.webp",

  // ─── COOLDOWN ─────────────────────────────────────────
  "Standing Quad Stretch": "/gifs/quad-stretch.webp",
  "Standing Hamstring Stretch": "/gifs/hamstring-stretch.webp",
  "Hip Flexor Lunge Stretch": "/gifs/hip-flexor-stretch.webp",
  "Calf Stretch": "/gifs/calf-stretch.webp",
  "Seated Glute Stretch": "/gifs/seated-glute-stretch.webp",
  "Child's Pose": "/gifs/childs-pose.webp",

  // ─── PHASE 1 ──────────────────────────────────────────
  "Glute Bridge": "/gifs/glute-bridge.webp",
  "Dead Bug": "/gifs/dead-bug.webp",
  "Romanian Deadlift": "/gifs/romanian-deadlift.webp",
  "KB Row": "/gifs/kb-row.webp",
  "Farmer Carry": "/gifs/farmer-carry.webp",
  "Tall Kneeling Press": "/gifs/tall-kneeling-press.webp",
  "KB Halo": "/gifs/kb-halo.webp",
  "Single-Leg Deadlift": "/gifs/single-leg-deadlift.webp",
  "Push-Up": "/gifs/push-up.webp",

  // ─── PHASE 2 ──────────────────────────────────────────
  "Hip Thrust (elevated)": "/gifs/hip-thrust-elevated.webp",
  "KB Swing": "/gifs/kb-swing.webp",
  "Goblet Squat (shallow)": "/gifs/goblet-squat.webp",
  "KB Press (standing)": "/gifs/kb-press.webp",
  "Suitcase Carry": "/gifs/suitcase-carry.webp",

  // ─── PHASE 3 ──────────────────────────────────────────
  "KB Windmill": "/gifs/kb-windmill.webp",

  // ─── PHASE 4 ──────────────────────────────────────────
  "Hip Thrust": "/gifs/hip-thrust.webp",
};

const videos = {
  // add YouTube IDs here as you find them
};

export default videos;
